import { useState, useEffect } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';

export function useTopic(topicId) {
  const [listState, setListState] = useState({
    data: {},
    isLoading: true,
    error: null,
  });

  const getTopic = async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const response = await BraveBupAPI.get(`/topics/${topicId}`);
      const data = response?.data || {};

      setListState((prevState) => ({
        ...prevState,
        data,
      }));
    } catch (error) {
      setListState((prevState) => ({
        ...prevState,
        error: {
          message:
            'Ocurrio un error inesperado, por favor vuelve a intentarlo.',
        },
        data: [],
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };
  useEffect(() => {
    getTopic();
  }, [topicId]);

  return {
    data: listState.data,
    isLoading: listState.isLoading,
    error: listState.error,
  };
}
